var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H4.5C3.94772 3 3.5 3.44772 3.5 4V27.5C3.5 28.0523 3.94772 28.5 4.5 28.5H28.5C29.0523 28.5 29.5 28.0523 29.5 27.5V20",
    stroke: "#2968C9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41652 23.3621C9.34061 23.6846 9.54057 24.0077 9.86313 24.0836C10.1857 24.1595 10.5087 23.9595 10.5846 23.637L9.41652 23.3621ZM25.5273 10.7914C25.6882 10.5018 25.5838 10.1365 25.2941 9.97558L20.5733 7.35361C20.2837 7.19271 19.9184 7.29711 19.7575 7.5868C19.5966 7.87649 19.701 8.24176 19.9907 8.40266L24.1869 10.7333L21.8562 14.9295C21.6953 15.2192 21.7998 15.5845 22.0894 15.7454C22.3791 15.9063 22.7444 15.8019 22.9053 15.5122L25.5273 10.7914ZM10.5846 23.637C11.5531 19.5215 13.4754 16.8958 15.9832 15.0455C18.5154 13.1771 21.6745 12.0754 25.1676 11.077L24.8378 9.92321C21.3315 10.9254 17.9897 12.0736 15.2707 14.0799C12.5273 16.1041 10.4483 18.9778 9.41652 23.3621L10.5846 23.637Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesExtract);
export default __webpack_public_path__ + "static/media/pipelines-extract.d8d2cda1cf0c115cf7029b7b9ced3642.svg";
export { ForwardRef as ReactComponent };